export default "__VITE_PUBLIC_ASSET__17f60593__"